'use client';
import { createTheme } from '@mui/material/styles';

// Colors matching calculator-source theme
// Original shades: main=#244757, 800=#506C79, 600=#7C909A, 400=#A7B5BB, 200=#D3DADD
const theme = createTheme({
  typography: {
    fontFamily: 'var(--font-roboto)',
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#244757', // rgb(36,71,87)
      light: '#D3DADD', // rgb(211,218,221) - was primary[200]
      dark: '#7C909A', // rgb(124,144,154) - was primary[600]
      A400: '#A7B5BB', // rgb(167,181,187) - was primary[400]
    },
    secondary: {
      main: '#244757', // same as primary in original theme
    },
  },
});

export default theme;
